module.exports = __webpack_public_path__ + "img/clock.79b8ee64.svg";